import { Component as VueComponent, defineComponent, h } from 'vue';

import { useIdoStore } from '@/store/store';
import Error from '@/views/Error.vue';

export default function withErrorHandler(Component: VueComponent) {
    // PRODUCT-26110 Phase 2B2 Task 5 batch 4: this HOC previously used Vue 2's global
    // `Vue.component(name, definition)` purely as a definition-object builder -- the
    // returned value is only ever consumed via this function's own return value
    // (confirmed by grep: no call site anywhere references the string
    // 'withErrorHandler'), so the global-registration side effect was never actually
    // relied on. `defineComponent` is the direct, real Vue 3 equivalent for that usage
    // and also gives `this` its real, augmented type inside render() ($store from
    // vue-app-injections.d.ts), instead of a global-API call that no longer exists.
    return defineComponent({
        render() {
            return useIdoStore().error
                ? h(Error)
                : h(Component);
        },
    });
}
